module.exports = __webpack_public_path__ + "static/img/page_05.ebcd017.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page_05.jpeg
// module id = jrz0
// module chunks = 0